<ion-item-sliding>
  <!-- (press)="showSheet()" -->

  <ion-item button detail="false" (click)="openEventDetails()">
    <ion-avatar slot="start" class="calendar-container text-center">
      <div class="calendar">
        <div class="calendar-header">
          <p>{{ validDate.toString() | transDate: 'MMM yyyy' }}</p>
        </div>
        <div class="calendar-body">
          <p>{{ validDate.toString() | transDate: 'd' }}</p>
        </div>
      </div>
    </ion-avatar>

    <ion-label>
      <h2 class="text-bold white-space-normal">
        {{ event?.eventName || event?.enaOrig }}
      </h2>
      <p class="text-ellipsis">{{ event?.strecke || event?.streckeconv }}</p>
      <!-- <p text-ellipsis>{{event.dateFormatted}}</p> -->
    </ion-label>

    <!-- Uncomment if needed
    <ion-avatar slot="end">
      <span
        [style.background-image]="'url(/assets/imgs/star.png)'"
        class="user-image-m bg-primary"
      ></span>
    </ion-avatar>
    -->
  </ion-item>

  <ion-item-options side="end">
    <ion-item-option color="danger" (click)="onDelete(event)">
      <!-- <div class="slider-elem"> -->
        <ion-icon name="trash" slot="start"></ion-icon>
        <span>{{ 'RESERVATION_RELEASE' | translate }}</span>
      <!-- </div> -->
    </ion-item-option>
  </ion-item-options>
</ion-item-sliding>

<!-- <ion-item-sliding >
  <ion-item (tap)="openEventDetails()">
    <div class="calendar-container" item-start text-center>
      <div class="calendar">
        <div class="calendar-header">
          <p>{{ validDate.toString() | transDate: 'MMM yyyy' }}</p>
        </div>
        <div class="calendar-body">
          <p>{{ validDate.toString() | transDate: 'd' }}</p>
        </div>
      </div>
    </div>
    <ion-row>
      <ion-col col-9 text-ellipsis>
        <h2 text-bold white-space-normal>{{ event?.eventName || event?.enaOrig }}</h2>
        <p text-ellipsis>{{ event?.strecke || event?.streckeconv }}</p>
      </ion-col>
    </ion-row>
  </ion-item>

  <ion-item-options side="end" >
    <ion-item-option color="danger" (swipe)="onDelete(event)"  (click)="onDelete(event)">
      <button ion-button color="danger">
        <ion-icon name="trash"></ion-icon>
      {{ 'RESERVATION_RELEASE' | translate }}
      </button>
    </ion-item-option>
  </ion-item-options>

</ion-item-sliding> -->